export const selectors = {
  list: (state) => state.team.list,
  teamsListLoaded: (state) => state.team.teamsListLoaded,
  employees: (state) => state.team.employees,
  loadingListStatus: (state) => state.team.loadingListStatus,
  submitNewMemberStatus: (state) => state.team.submitNewMemberStatus,
  loadingMember: (state) => state.team.loadingMember,
  employeeDetailsLoaded: (state) => state.team.employeeDetailsLoaded,
  loadingEditedMember: (state) => state.team.loadingEditedMember,
  pagination: (state) => state.team.pagination,
  filters: (state) => state.team.filters,
};
